<form [formGroup]="formGroup" (ngSubmit)="save()">
  <div class="table-wrapper">
    <table>
      <tr>
        <td>ID</td>
        <td>{{ user.id }}</td>
      </tr>
      <tr>
        <td i18n>Name</td>
        <td>
          @if (!user.name) {
            <i i18n>Kein Name</i>
          }
          {{ user.name }}</td
        >
      </tr>
      <tr>
        <td i18n>E-Mail-Adresse</td>
        <td>{{ user.email }}</td>
      </tr>
      <tr>
        <td i18n>E-Mail-Adresse bestätigt</td>
        @if (user.emailConfirmed) {
          <td i18n>Ja</td>
        } @else {
          <td i18n>Nein</td>
        }
      </tr>
      <tr>
        <td i18n>Rollen</td>
        <td>
          <mat-form-field class="role-field">
            <mat-label i18n>Rollen</mat-label>
            <mat-chip-grid #chipList>
              @for (role of roles; track role) {
                <mat-chip-row (removed)="removeRole(role)">
                  {{ role }}
                  <button matChipRemove><mat-icon>cancel</mat-icon></button>
                </mat-chip-row>
              }
              <input
                #roleInput
                placeholder="Neue Rolle vergeben"
                i18n-placeholder
                formControlName="roleFilter"
                [matAutocomplete]="auto"
                [matChipInputFor]="chipList"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                [matChipInputAddOnBlur]="true"
                (matChipInputTokenEnd)="addRole($event)"
              />
            </mat-chip-grid>
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="roleSelected($event)">
              @for (role of filteredRoles | async; track role) {
                <mat-option [value]="role">{{ role }}</mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td i18n>Registrierungsdatum</td>
        <td>{{ user.createdAt | date: 'medium' }}</td>
      </tr>
    </table>
  </div>

  <mat-divider></mat-divider>
  <div class="buttons-wrapper">
    <button
      mat-raised-button
      type="submit"
      color="primary"
      [dtOverlayProgress]="formGroup.disabled"
      [disabled]="formGroup.disabled"
      class="action-button"
      i18n
      >Speichern</button
    >
    <button mat-stroked-button type="button" (click)="reset()" [disabled]="formGroup.disabled" class="action-button" i18n>Verwerfen</button>
    <button
      mat-stroked-button
      type="button"
      color="warn"
      [disabled]="formGroup.disabled || (isCurrentUser$ | async)"
      matTooltip="Du kannst Deinen eigenen Account hier nicht löschen"
      [matTooltipDisabled]="(isCurrentUser$ | async) === false"
      (click)="deleteUser()"
      class="action-button"
      i18n
      >Benutzer löschen</button
    >
  </div>
</form>
